import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET_CALENDAR_EVENT,
	SET_CALENDAR_EVENTS,
	SET_EVENT_TAGS
} = actionDeclarer;

const calendarReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET_CALENDAR_EVENT:
			return {
				...state,
				calendarEvent: payload
			};
		case SET_CALENDAR_EVENTS:
			return {
				...state,
				calendarEvents: payload
			};
		case SET_EVENT_TAGS:
			return {
				...state,
				eventTags: payload
			};
		default:
			return state;
	}
};

export default calendarReducer;
